import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { collections } from "../data/mockData";

function Categories() {
  return (
    <div className="bg-cream min-h-screen">

      {/* HERO */}
      <section className="py-20 text-center">
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-4">
          Our Categories
        </h1>
        <p className="text-[#6B665F] text-lg font-light">
          Explore timeless collections crafted with purpose
        </p>
      </section>

      {/* CATEGORY GRID */}
      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {collections.map(function (collection, index) {
            return (
              <Link
                key={collection.id}
                to={"/category/" + collection.name.toLowerCase()}
                className="group relative overflow-hidden aspect-[16/9]"
              >

                {/* IMAGE */}
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* OVERLAY */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/30 to-transparent"></div>

                {/* CONTENT */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="font-serif text-2xl mb-2">
                    {collection.name}
                  </h3>

                  <p className="text-sm opacity-90">
                    {collection.description}
                  </p>

                  <div className="mt-4 flex items-center gap-2 text-xs uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Explore <ArrowRight size={14} />
                  </div>
                </div>

              </Link>
            );
          })}

        </div>
      </section>
    </div>
  );
}

export default Categories;